import { Box, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function BlogMarkdown({ content }: { content: string }) {
  return (
    <Box
      color="gray.300"
      lineHeight="1.8"
      fontSize={{ base: 'md', md: 'lg' }}
      sx={{
        'h2': {
          color: 'white',
          fontSize: { base: 'xl', md: '2xl' },
          fontWeight: 'bold',
          mt: 10,
          mb: 4,
        },
        'h3': {
          color: 'white',
          fontSize: { base: 'lg', md: 'xl' },
          fontWeight: 'semibold',
          mt: 8,
          mb: 3,
        },
        'p': { mb: 4 },
        'ul, ol': { pl: 6, mb: 4 },
        'li': { mb: 2 },
        'a': {
          color: 'primary.400',
          textDecoration: 'underline',
          _hover: { color: 'primary.300' },
        },
        'table': {
          width: '100%',
          borderCollapse: 'collapse',
          mb: 6,
          fontSize: 'sm',
          display: 'block',
          overflowX: 'auto',
        },
        'th, td': {
          border: '1px solid',
          borderColor: 'whiteAlpha.200',
          px: 3,
          py: 2,
          textAlign: 'left',
        },
        'th': {
          bg: 'gray.800',
          color: 'white',
          fontWeight: 'semibold',
        },
        'blockquote': {
          borderLeft: '4px solid',
          borderColor: 'primary.500',
          pl: 4,
          color: 'gray.400',
          fontStyle: 'italic',
          mb: 4,
        },
        'code': {
          bg: 'gray.800',
          px: 1,
          py: 0.5,
          borderRadius: '4px',
          fontSize: '0.9em',
        },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => {
            if (href?.startsWith('/')) {
              return (
                <Link as={RouterLink} to={href} color="primary.400">
                  {children}
                </Link>
              );
            }
            return (
              <Link href={href} isExternal color="primary.400">
                {children}
              </Link>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
}
